(function() {
    function onDocumentReady(fn) {
        if (document.readyState !== 'loading') {
            fn();
        } else {
            document.addEventListener('DOMContentLoaded', fn);
        }
    }

    var fetchVariantAvailability = async function(variantId) {
        if(!variantId) return;
        var cleanPath = window.location.href.split('?')[0];
        var destPath = cleanPath + '?variant=' + variantId + '&view=api-multilocation-availability';
        var fetchedData = await fetch(destPath)
        var stringData = await fetchedData.text();
        var responseHtml =  new DOMParser().parseFromString(stringData, 'text/html');
        var responseBodyEl = responseHtml.querySelector('body');
        return JSON.parse(responseBodyEl.innerText);
    }

    var updateVariantAvailability = async function(variantId, availabilityTemplate){
        var availabilitySingleTemplate = document.querySelector('[data-multilocation-availability-single-template]');
        var availabilityOosTemplate = document.querySelector('[data-multilocation-availability-oos-template]');
        var availabilityNoneSelectedTemplate = document.querySelector('[data-multilocation-availability-none-selected-template]');

        var availabilityJSON = await fetchVariantAvailability(variantId);
        if(availabilityJSON) {
            availabilityTemplate.innerHTML = '';

            if(availabilityJSON.length) {
                var newAvailabilityContent = availabilityJSON.map(function(availability){
                    if(!availability.available) return '';
                    var name = availability.location.name;
                    var newSingleAvailability = availabilitySingleTemplate.innerHTML.replace('LOCATION', name);
                    return newSingleAvailability;
                });
                availabilityTemplate.innerHTML = newAvailabilityContent.join('');
            } else {
                availabilityTemplate.innerHTML = availabilityOosTemplate.innerHTML;
            }
        } else {
            availabilityTemplate.innerHTML = availabilityNoneSelectedTemplate.innerHTML;
        }
    }

    onDocumentReady(function(){
        var variantSelector = document.querySelector('[name="id"]');
        var variantsSelectElement = document.querySelector('variant-selects select');
        var availabilityTemplate = document.querySelector('[data-multilocation-availability-template]');

        if(variantSelector && availabilityTemplate && variantsSelectElement) {
            // ONCHANGE
            variantsSelectElement.addEventListener('change', function(e){
                window.setTimeout(function(){
                    console.log('VALUE:', variantsSelectElement.value);
                    var currentVariantId = !!variantsSelectElement.value ? variantSelector.value : false;
                    console.log('VARIANT ID:', currentVariantId);
                    updateVariantAvailability(currentVariantId, availabilityTemplate);
                }, 500);
            });

            // ONLOAD
            var currentVariantId = !!variantsSelectElement.value ? variantSelector.value : false;
            window.setTimeout(function(){
                updateVariantAvailability(currentVariantId, availabilityTemplate);
            }, 500);
        }

        if(document.querySelector('[data-multilocation-availability-single-variant="true"]')) {
            window.setTimeout(function(){
                updateVariantAvailability(variantSelector.value, availabilityTemplate);
            }, 500);
        }
    });
})();